/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json$Params {
  nip: string;
  plzId: number;
}

export function apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json.PATH, 'get');
  if (params) {
    rb.path('nip', params.nip, {});
    rb.path('plzId', params.plzId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      }>;
    })
  );
}

apiWebInstytucjeNipPlikiPlzIdIdentyfikatoryGet$Json.PATH = '/api/web/instytucje/{nip}/pliki/{plzId}/identyfikatory';
